var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTipPointer = function SvgTipPointer(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 84,
    viewBox: "0 0 81 84",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.9678 63.7046C63.8261 64.3998 63.9584 65.6592 63.2632 66.5176C62.5679 67.3759 61.3085 67.5082 60.4502 66.813L62.9678 63.7046ZM24.8741 13.2038C25.227 12.1571 26.3616 11.5947 27.4082 11.9475L44.465 17.6978C45.5117 18.0507 46.0742 19.1852 45.7213 20.2319C45.3685 21.2786 44.2339 21.8411 43.1872 21.4882L28.0256 16.3768L22.9142 31.5384C22.5614 32.5851 21.4268 33.1476 20.3801 32.7947C19.3334 32.4419 18.771 31.3073 19.1238 30.2606L24.8741 13.2038ZM60.4502 66.813C44.4975 53.8922 34.0139 32.9591 24.9774 14.731L28.5612 12.9544C37.6885 31.3656 47.8176 51.4339 62.9678 63.7046L60.4502 66.813Z",
    fill: "#DBE3EB"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTipPointer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tip-pointer.f5ea8eb8.svg";
export { ForwardRef as ReactComponent };